import { UserNoticeSectionType } from './UserNoticeSectionType';

export const UserNoticeSectionTypeOptions = [
    {
        id: UserNoticeSectionType.Open,
        name: 'Open Applications/Approved Loans',
    },
    {
        id: UserNoticeSectionType.Closed,
        name: 'Outstanding Loans',
    },
    {
        id: UserNoticeSectionType.DeadDeals,
        name: 'Dead Deals',
    },
    {
        id: UserNoticeSectionType.Repaid,
        name: 'Repaid Loans',
    },
    {
        id: UserNoticeSectionType.Missing,
        name: 'Missing Notices',
    },
    {
        id: UserNoticeSectionType.All,
        name: 'All',
    },
];
